<bl-modal-content #content
  [title]="headerTitle">
  <div body class="main-body">
    <table class="table table-bordered" border="2">
      <tr class="header-first">
        <td class="title" colspan="2">コンタクト状況別背景色を設定してください。</td>
      </tr>
      <tr>
        <th class="header-width">
          <span>実施状況</span>
        </th>
        <td>
          <div class="impl-body">
            <div class="percent-under red"></div>
            <div class="form-size--s">
              <bl-number-input #contactImplementationStatus1
                [(value)]="result && result.contactImplementationStatus.contactStatus1"
                [option]="{ minus: false, min: 1, max: 99 }"
                (valueChange)="onChangeImplementationStatus1($event, contactImplementationStatus1)">
              </bl-number-input>
            </div>
            <div class="under-text">
              <span>%以下</span>
            </div>
            <div class="percent-under yellow"></div>
            <div class="form-size--s">
              <bl-number-input #contactImplementationStatus2
                [(value)]="result && result.contactImplementationStatus.contactStatus2"
                [option]="{ minus: false, min: 1, max: 99 }"
                (valueChange)="onChangeImplementationStatus2($event, contactImplementationStatus2)">
              </bl-number-input>
            </div>
            <div class="under-text">
              <span>%以下</span>
            </div>
            <div class="percent-under blue"></div>
            <div class="form-size--s">
              <bl-number-input #contactImplementationStatus3
                [(value)]="result && result.contactImplementationStatus.contactStatus3"
                [option]="{ minus: false, min: 1, max: 99 }"
                (valueChange)="onChangeImplementationStatus3($event, contactImplementationStatus3)">
              </bl-number-input>
            </div>
            <div class="under-text">
              <span>%以下</span>
            </div>
            <div class="percent-under green"></div>
            <span class="under-text">100%</span>
          </div>
        </td>
      </tr>
      <tr>
        <th>成約状況</th>
        <td>
          <div class="impl-body">
            <div class="percent-under red"></div>
            <div class="form-size--s">
              <bl-number-input #contactContractStatus1
                [(value)]="result && result.contactContractStatus.contactStatus1"
                [option]="{ minus: false, min: 1, max: 99 }"
                (valueChange)="onChangeContractStatus1($event, contactContractStatus1)">
              </bl-number-input>
            </div>
            <div class="under-text">
              <span>%以下</span>
            </div>
            <div class="percent-under yellow"></div>
            <div class="form-size--s">
              <bl-number-input #contactContractStatus2
                [(value)]="result && result.contactContractStatus.contactStatus2"
                [option]="{ minus: false, min: 1, max: 99 }"
                (valueChange)="onChangeContractStatus2($event, contactContractStatus2)">
              </bl-number-input>
            </div>
            <div class="under-text">
              <span>%以下</span>
            </div>
            <div class="percent-under blue"></div>
            <div class="form-size--s">
              <bl-number-input #contactContractStatus3
                [(value)]="result && result.contactContractStatus.contactStatus3"
                [option]="{ minus: false, min: 1, max: 99 }"
                (valueChange)="onChangeContractStatus3($event, contactContractStatus3)">
              </bl-number-input>
            </div>
            <div class="under-text">
              <span>%以下</span>
            </div>
            <div class="percent-under green"></div>
            <span class="under-text">100%</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/contact-bg-color-setting/contact-bg-color-setting-modal.component.html